<template>
  <v-autocomplete class="app-autocomplete" outlined dense v-bind="$attrs" v-on="$listeners">
    <!-- Slots COM escopo (#item, #selection). Vuetify lê via $scopedSlots. -->
    <template v-for="(_, slot) in $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>

    <!-- NÃO REMOVER e NÃO RENOMEAR a variável `plainSlot` para `slot`.
         Este loop reexpõe em $slots os slots SEM escopo (#no-data, #append, #prepend, #label...),
         que o Vuetify 2 lê direto de this.$slots['no-data'] / this.$slots.append, não de $scopedSlots.

         A variável PRECISA ter nome diferente da usada no loop acima: o compilador do Vue indexa
         `el.scopedSlots` pela expressão do nome dinâmico do slot, então dois v-for com `#[slot]`
         colidem nessa chave e o segundo descarta o primeiro EM TEMPO DE COMPILAÇÃO — o bundle sai
         com um `_l` só e todos os slots com escopo somem silenciosamente. -->
    <template v-for="(_, plainSlot) in $slots" #[plainSlot]>
      <slot :name="plainSlot" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'AppAutocomplete',
  inheritAttrs: false,
}
</script>

<style scoped>
.app-autocomplete ::v-deep .v-input__control > .v-input__slot {
  border-radius: 10px !important;
}
</style>
